import React, { forwardRef, HTMLAttributes, useContext } from 'react';

import { withTheme } from '@emotion/react';
import styled from '@emotion/styled';
import { ThemeProps, variant } from '@lucid/theme';

import { NavbarContext } from './navbar';

export type NavbarToggleVariants = 'default';

export interface NavbarToggleButtonProps {
  /** Allows the component to get additional styles. */
  className?: string;
  /** The theme object to apply styles to the NavbarToggleButton component. */
  theme: ThemeProps['theme'];
  /** The available variants for the NavbarToggleButton component. */
  variant?: NavbarToggleVariants;
}

const NavbarToggleButton = styled.button<NavbarToggleButtonProps>(
  ({ theme }) => ({
    label: 'navbarToggle',
    display: 'none',
    background: 'transparent',
    border: 0,
    fontSize: 'inherit',
    cursor: 'pointer',
    [`@media (max-width: ${theme.navbar.collapseAt})`]: {
      display: 'block'
    }
  }),
  variant({
    scale: 'navbar.toggle',
    variants: {
      defaultVariant: {}
    }
  })
);

const NavbarToggleWrapper = forwardRef<
HTMLButtonElement,
HTMLAttributes<HTMLButtonElement> & NavbarToggleButtonProps
>(({ children, className, variant = 'default', ...rest }, ref) => {
  const { toggleExpanded } = useContext(NavbarContext);

  return (
    <NavbarToggleButton
      {...rest}
      ref={ref}
      className={className}
      onClick={toggleExpanded}
      variant={variant}
    >
      {children}
    </NavbarToggleButton>
  );
});

const NavbarToggle = withTheme(NavbarToggleWrapper);

export { NavbarToggle };
export default NavbarToggle;
